import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, CheckCircle } from 'lucide-react';
const cities = ['Los Angeles', 'New York', 'London', 'Toronto', 'Sydney', 'Chicago', 'Miami', 'Austin', 'Denver', 'Seattle', 'Portland', 'San Francisco', 'Boston', 'Atlanta', 'Phoenix'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [city, setCity] = useState('');
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 4000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showPopup = () => {
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    setCity(randomCity);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next appearance
      setTimeout(showPopup, Math.random() * 5000 + 15000); // 15-20 seconds
    }, 4000);
  };
  return <AnimatePresence data-id="element-136">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm w-[calc(100%-2rem)]" data-id="element-137">
          <div className="bg-white rounded-lg shadow-xl p-4 border border-[#E8D5D5] flex items-center gap-4" data-id="element-138">
            <div className="flex-shrink-0 w-12 h-16 bg-gray-200 rounded overflow-hidden" data-id="element-139">
              <img src="https://cdn.magicpatterns.com/uploads/3NrgeHMH1zxC1jhh8TEW3X/heylloyd-image-1770228763545.png" alt="Book cover" className="w-full h-full object-cover" data-id="element-140" />
            </div>
            <div data-id="element-141">
              <p className="text-sm text-[#2D1B4E] font-medium leading-tight" data-id="element-142">
                Someone just purchased <br data-id="element-143" />
                <span className="italic" data-id="element-144">From Trauma to Self-Love</span>
              </p>
              <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-145">
                <MapPin className="w-3 h-3" data-id="element-146" />
                <span data-id="element-147">in {city}</span>
                <span className="mx-1" data-id="element-148">•</span>
                <span className="text-green-600 flex items-center gap-0.5" data-id="element-149">
                  <CheckCircle className="w-3 h-3" data-id="element-150" /> Verified
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}